import React from 'react';
import { Select, SelectProps } from '@arco-design/web-react';

export function SelectOptions({
  value,
  onChange,
  options,
  placeholder = '全部',
  ...rest
}: SelectProps) {
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      options={options}
      allowClear
      {...rest}
    />
  );
}
